import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar   from './components/Navbar';
import Hero     from './components/Hero';
import Services from './components/Services';
import Products from './components/Products';
import Training from './components/Training';
import Clients  from './components/Clients';
import WhyUs    from './components/WhyUs';
import Contact  from './components/Contact';
import Footer   from './components/Footer';
import Careers  from './components/Careers';
import ConnectStudents from './components/ConnectStudents';
import PulseCRM from './components/PulseCRM';
import NammaCET from './components/NammaCET';
import MindPlanAI from './components/MindPlanAI';
import Projects from './components/Projects';
import AboutUs from './components/AboutUs';
import Blog from './components/Blog';
import OurTeam from './components/OurTeam';
import ChatWidget from './components/ChatWidget';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function MainPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Products />
        <Training />
        <Clients />
        <WhyUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/connect-students" element={<ConnectStudents />} />
        <Route path="/pulse-crm" element={<PulseCRM />} />
        <Route path="/namma-cet" element={<NammaCET />} />
        <Route path="/mindplan-ai" element={<MindPlanAI />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/team" element={<OurTeam />} />
      </Routes>
      <ChatWidget />
    </BrowserRouter>
  );
}
